var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('v-dialog', {
    attrs: {
      "width": "560"
    },
    model: {
      value: _vm.show,
      callback: function ($$v) {
        _vm.show = $$v;
      },
      expression: "show"
    }
  }, [_vm.show ? _c('v-card', [_c('v-card-title', {
    staticClass: "subtitle-1",
    attrs: {
      "primary-title": ""
    }
  }, [_vm._v("신규 브랜드 등록")]), _c('v-card-text', [_c('v-text-field', {
    staticClass: "mt-3",
    attrs: {
      "label": "브랜드 이름",
      "placeholder": " ",
      "hide-details": ""
    },
    model: {
      value: _vm.editItem.name,
      callback: function ($$v) {
        _vm.$set(_vm.editItem, "name", $$v);
      },
      expression: "editItem.name"
    }
  }), _c('v-text-field', {
    staticClass: "mt-3",
    attrs: {
      "label": "브랜드 코드",
      "placeholder": " ",
      "hide-details": ""
    },
    model: {
      value: _vm.editItem.code,
      callback: function ($$v) {
        _vm.$set(_vm.editItem, "code", $$v);
      },
      expression: "editItem.code"
    }
  })], 1), _c('v-card-title', {
    staticClass: "subtitle-1",
    attrs: {
      "primary-title": ""
    }
  }, [_vm._v("썸네일")]), _c('v-card-text', [_c('product-image', {
    attrs: {
      "label": "썸네일"
    },
    on: {
      "remove": _vm.removeThumb
    },
    model: {
      value: _vm.editItem.thumb,
      callback: function ($$v) {
        _vm.$set(_vm.editItem, "thumb", $$v);
      },
      expression: "editItem.thumb"
    }
  })], 1), _c('v-card-title', {
    staticClass: "subtitle-1",
    attrs: {
      "primary-title": ""
    }
  }, [_vm._v("서브 썸네일")]), _c('v-card-text', [_c('product-image', {
    attrs: {
      "label": "서브 썸네일"
    },
    on: {
      "remove": _vm.removeThumb
    },
    model: {
      value: _vm.editItem.subThumb,
      callback: function ($$v) {
        _vm.$set(_vm.editItem, "subThumb", $$v);
      },
      expression: "editItem.subThumb"
    }
  })], 1), _c('v-card-actions', [_c('v-spacer'), _c('v-btn', {
    attrs: {
      "text": ""
    },
    on: {
      "click": _vm.cancel
    }
  }, [_vm._v("취소")]), _c('v-btn', {
    attrs: {
      "color": "primary",
      "text": ""
    },
    on: {
      "click": _vm.save
    }
  }, [_vm._v("등록")])], 1)], 1) : _vm._e()], 1);

}
var staticRenderFns = []

export { render, staticRenderFns }